import { useSplitTests } from '@api/lendingAPI/lapiHooks';
import { getAccountsQueryConfig } from '@api/lendingAPI/queryConfigs';
import { TAccount } from '@helpers/Accounts/accounts.types';
import { getAccountIsRBL } from '@helpers/Accounts/getAccountIsRBL';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../iwQueryClient/useStateKey';

export const useRepaymentReductionSplitTest = (
    accountId: NonNullable<TAccount['account_id']>
) => {
    const stateKey = useStateKey();
    const isInSplitTest = useSplitTests('de_repayment_reduction_test_2025');

    const { data: account } = useQuery({
        ...getAccountsQueryConfig(stateKey),
        select: (data) =>
            data.data.accounts.find(
                (account) => account.account_id === accountId
            )
    });

    const isRBL = account ? getAccountIsRBL(account) : false;

    return {
        isInRepaymentReductionSplitTest: isInSplitTest && !isRBL
    };
};
